import { gql } from "@apollo/client"
import { PACKING_ALLOTMENT_FRAG } from "./allocation.fragment.gql"

export const INWARD_ALLOCATIONS = gql`
  query InwardAllocations(
    $search: String
    $offset: Int
    $limit: Int
    $holdingAreaId: ID
    $startDate: Date
    $endDate: Date
    $inwardId: ID
    $depotId: ID
    $varietyId: ID
  ) {
    inwardAllocations(
      search: $search
      offset: $offset
      limit: $limit
      holdingAreaId: $holdingAreaId
      startDate: $startDate
      endDate: $endDate
      inwardId: $inwardId
      depotId: $depotId
      varietyId: $varietyId
    ) {
      id
      createdAt
      ggn
      metadata
      allottedWeight
      allottedSku
      availableWeight
      availableSkusCount
      plotCommoditySample {
        id
        totalDetection
        detectionCount
        physicalStatus
        chemicalStatus
        maxDetection
        chemicalStatusDisplay
        physicalStatusDisplay
        observations {
          id
          tags
          qualityParameter {
            id
            name
            mrl
          }
          detectionCount
          score
        }
      }
      inward {
        id
        grn
        metadata
        date
        status
        weigh {
          id
          skuType {
            id
            name
          }
          netWeight
          inwardedQuantity
          finalWeight
        }
        booking {
          id
          date
          schedule {
            id
            vehicle {
              id
              registrationNumber
              chassisNumber
            }
            gatePass
            aggregator {
              id
              fullName
            }
            variety {
              id
              name
            }
            plotCommodity {
              id
              registrationCode
            }
            plot {
              id
              farmer {
                id
                fullName
              }
            }
          }
        }
      }
      holdingArea {
        id
        name
        isActive
      }
      packingallotmentSet {
        ...packingallotmentSet
      }
    }
  }
  ${PACKING_ALLOTMENT_FRAG}
`

export const INWARD_ALLOCATION = gql`
  query InwardAllocation($id: ID!) {
    inwardAllocation(id: $id) {
      id
      createdAt
      metadata
      ggn
      allottedWeight
      allottedSku
      availableWeight
      availableSkusCount
      packingallotmentSet {
        ...packingallotmentSet
      }
      plotCommoditySample {
        id
        totalDetection
        detectionCount
        physicalStatus
        chemicalStatus
        maxDetection
        chemicalStatusDisplay
        physicalStatusDisplay
        observations {
          id
          tags
          qualityParameter {
            id
            name
            mrl
          }
          detectionCount
          score
        }
      }
      inward {
        id
        grn
        date
        status
        weigh {
          id
          skuType {
            id
            name
            capacity
            capacityUnit {
              id
              name
              codename
            }
          }
          netWeight
          inwardedQuantity
          finalWeight
        }
        booking {
          id
          date
          schedule {
            id
            destinationDepot {
              id
              name
            }
            vehicle {
              id
              registrationNumber
              chassisNumber
            }
            gatePass
            aggregator {
              id
              fullName
            }
            variety {
              id
              name
            }
            plotCommodity {
              id
              registrationCode
            }
            plot {
              id
              farmer {
                id
                fullName
              }
            }
          }
        }
      }
      holdingArea {
        id
        name
        isActive
      }
    }
  }
  ${PACKING_ALLOTMENT_FRAG}
`

export const ELIGIBLE_EXPORT_CUSTOMERS_BY_SAMPLE = gql`
  query eligibleExportCustomersBySample($sampleId: ID!) {
    eligibleExportCustomersBySample(sampleId: $sampleId) {
      id
      name
    }
  }
`
